import { Injectable, signal } from '@angular/core';
import { NavigationItem } from '@base/navigation/navigation.types';
import { Navigation } from 'app/core/navigation/navigation.types';
import { cloneDeep } from 'lodash';
import { defaultNavigation } from './data';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly _defaultNavigation: NavigationItem[] = defaultNavigation;

  // Initialize signal with computed navigation data
  private _navigationData = signal<Navigation>(this.computeNavigationData());

  readonly navigation = this._navigationData.asReadonly();

  /**
   * Compute navigation data
   */
  private computeNavigationData(): Navigation {
    return {
      default: cloneDeep(this._defaultNavigation),
    };
  }
}
